export default __webpack_public_path__ + "static/media/pics (2).9d51c20e.svg";